/**
 * 自动生成， 请不要手工修改！
 */

export enum EndorsementType {
  REG_PAPER,
  CITIZEN_CARD,
  GENERAL_PROOF,
}
